import { useEffect, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';

import { getTeachers } from '../../../api/teachers';

const emptyTask = {
  createdByUser: 0,
  task_title: '',
  task_descr: '',
  task_object: '',
  task_key: '',
  task_recipient: '',
};

export function TaskCreatePopup({
  taskPopupVisible,
  hideEvent,
  createTaskOptions,
  toCreateTask,
  setTask,
}) {
  const [teachers, setTeachers] = useState([]);
  const [loadingTeachers, setLoadingTeachers] = useState(false);

  useEffect(() => {
    async function loadTeachers() {
      setLoadingTeachers(true);

      try {
        const result = await getTeachers();
        setTeachers(Array.isArray(result) ? result : []);
      } catch (error) {
        console.error('Oktatók betöltési hiba:', error);
        setTeachers([]);
      } finally {
        setLoadingTeachers(false);
      }
    }

    if (taskPopupVisible) {
      loadTeachers();
    }
  }, [taskPopupVisible]);

  const task = toCreateTask ?? emptyTask;

  const updateField = (field, value) => {
    if (!setTask) return;

    setTask((prev) => ({
      ...emptyTask,
      ...prev,
      [field]: value,
    }));
  };

  const handleCreate = () => {
    if (!task.task_title?.trim()) {
      alert('A feladat címe kötelező.');
      return;
    }

    if (!task.task_descr?.trim()) {
      alert('A leírás kötelező.');
      return;
    }

    if (!task.task_recipient) {
      alert('A címzett kiválasztása kötelező.');
      return;
    }

    createTaskOptions?.onClick?.();
  };

  return (
    <Dialog
      open={Boolean(taskPopupVisible)}
      onClose={hideEvent}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>Feladat létrehozása</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label='Feladat'
            value={task.task_title ?? ''}
            onChange={(e) => updateField('task_title', e.target.value)}
            fullWidth
            size='small'
          />

          <TextField
            label='Leírás'
            value={task.task_descr ?? ''}
            onChange={(e) => updateField('task_descr', e.target.value)}
            multiline
            minRows={5}
            fullWidth
            size='small'
          />

          <FormControl fullWidth size='small'>
            <InputLabel>Címzett</InputLabel>
            <Select
              label='Címzett'
              value={task.task_recipient ?? ''}
              onChange={(e) => updateField('task_recipient', e.target.value)}
              disabled={loadingTeachers}
            >
              {teachers.map((teacher) => (
                <MenuItem key={teacher.id} value={teacher.id}>
                  {teacher.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={hideEvent}>Bezár</Button>

        <Button variant='contained' onClick={handleCreate}>
          {createTaskOptions?.text ?? 'Létrehoz'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
